export class Config {
  public static readonly clientId = "44cd36Xg2V81hMquahgUFdiXY55U0tOQ";
  public static readonly clientSecret = "X79kMfk6HKbO9o85NjJ99ez0eJy22Q5l";
  public static readonly grantTypePassword = "password";
  public static readonly grantTypeRefresh = "refresh_token";
  public static readonly baseUrl = window.location.protocol + "//" + window.location.hostname;
  public static readonly authUrl = Config.baseUrl + "/oauth/access_token";
  public static readonly googleMapsApiKey = "AIzaSyA4FRJy4vZL5H83P-t-fvkmfpY8nkksSjM";
  public static readonly production = true;
  public static readonly fallbackCoordinates = {
    lat: 48.2937934,
    lng: 14.2954332
  }
}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/environments/environment.ts